<template>
  <div class="dx-user-avatar">
    <span class="dx-user-avatar__link">
      <img class="dx-user-avatar__photo" :src="image" v-if="image">
      <dx-letter-avatar :name="name" v-if="!image"></dx-letter-avatar>
      <h2 class="dx-user-avatar__name">{{ name }}</h2>
      <p class="dx-user-avatar__items"><strong>{{ items }}</strong> {{ $t('items') }}</p>
    </span>
  </div>
</template>

<script>
import DxLetterAvatar from './DxLetterAvatar.vue'
export default {
  name: 'dx-user-avatar',
  components: { DxLetterAvatar },
  props: {
    id: Number,
    name: String,
    image: String,
    items: {
      type: Number,
      default: 0
    }
  },
  computed: {
    link () {
      return {
        name: 'home'
        // name: 'profile',
        // id: this.id
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DxUserAvatar.vue